<template>
  <div class="container_box">
    <div class="questionnaire_box">
      <!--选择题型-->
      <Card :bordered="false" dis-hover class="question_type_box">
        <template #title>
          <h2 class="title_box">{{ $t('key1002995') }}</h2>
        </template>
        <div class="question_type_item">
          <Button type="primary" v-for="(item,index) in questionTypeList"
            :key="index" @click="selectQuestionBtn(item.value)">{{ item.name }}
          </Button>
        </div>
      </Card>
      <!--问卷内容-->
      <div class="questionnaire_content">
        <div class="questionnaire_title">
          <Input class="title" :placeholder="$t('key1002988')" v-model.trim="questionnaireTitle"></Input>
          <Input class="text" type="textarea" :placeholder="$t('key1002989')" :autosize="{ minRows: 3, maxRows: 6}"
            v-model="direction"></Input>
        </div>
        <draggable
          v-model="questionnaireList"
          chosenClass="chosen"
          forceFallback="true"
          class="questionnaire_list"
          group="title"
          :disabled="disabledCard"
          :animation="1000"
          draggable=".questionnaire_list_item">
          <div class="questionnaire_list_item" :class="disabledCard ? '' : 'moveStyles'" v-for="(item,index) in questionnaireList" :key="index">
            <Icon class="deleteIcon" color="#2D8CF0" :size="35" type="ios-close" v-if="questionnaireList.length>1"
              @click.native="deleteQuestionnaireBtn(index)"/>
            <!--题型-->
            <Tag color="blue" class="mb20">{{ typeObj[item.questionType - 1] }}</Tag>
            <!--填写要求-->
            <div class="flex align-items-center mb20">
              <span>{{ $t('key1000476') }}</span>
              <RadioGroup v-model="item.mandatory">
                <Radio :label="1">{{ $t('key1000304') }}</Radio>
                <Radio :label="0">{{ $t('key1002996') }}</Radio>
              </RadioGroup>
            </div>
            <!--标题-->
            <div class="flex align-items-center mb20">
              <span class="title" :class="item.mandatory === 1 ? 'required_styles' : ''">
                {{ index <= 9 ? ('0' + (index + 1) + '：') : (index + 1) + '：' }}
              </span>
              <Input :placeholder="$t('key1002990')" v-model.trim="item.questionTitle" style="width: 450px;" clearable></Input>
            </div>
            <!--选项-->
            <template v-if="item.ymsQuestionnaireQuestionsItems">
              <draggable
                v-model="item.ymsQuestionnaireQuestionsItems"
                chosenClass="chosen"
                forceFallback="true"
                class="option_box"
                :group="{pull:false, put:false}"
                :disabled="disabledOptions || item.ymsQuestionnaireQuestionsItems.length<=1"
                :animation="1000"
                handle=".moveIcon"
                draggable=".option_box_item">
                <div class="option_box_item" v-for="(ele,idx) in item.ymsQuestionnaireQuestionsItems" :label="ele.itemContent" :key="idx">
                  <!--单选-->
                  <div class="option_box_item_box" :class="disabledOptions ? 'moveIconStyles' : ''">
                    <div class="flex align-items-center" v-if="item.questionType !== 3">
                      <Icon type="md-move" class="moveIcon" color="#2D8CF0" :size="24" v-if="item.ymsQuestionnaireQuestionsItems.length>1"/>
                      <span class="radio_item" v-if="item.questionType === 1"></span>
                      <span class="checkbox_item" v-if="item.questionType === 2"></span>
                      <span class="cursor" v-show="!ele.editType" @click="editOptionTitle('option_'+item.type+'_', index, idx)">
                      {{ ele.itemContent }}
                    </span>
                      <Input :element-id="'option_'+item.type+'_' + idx" :placeholder="$t('key1002991')" style="width: 450px;"
                        v-model.trim="ele.itemContent" @on-blur="OptionBlur(index, idx)" v-show="ele.editType"></Input>
                    </div>
                    <Icon class="ml5 cursor" color="#2D8CF0" :size="30" type="ios-close"
                      v-if="item.ymsQuestionnaireQuestionsItems.length>1 && item.questionType !== 3"
                      @click.native="deleteOptionTitle(index, idx)"/>
                  </div>
                </div>
              </draggable>
            </template>
            <!--添加选项-->
            <div class="add_option_box" v-if="item.questionType !== 3">
              <Button type="text" class="themeColor" @click="addOptionsBtn(index)">{{ $t('key1002997') }}</Button>
              <Button type="text" class="themeColor ml30" @click="addOtherOptionsBtn(index)"
                :disabled="item.ymsQuestionnaireQuestionsItems.some((talg) => {return talg.otherType})">{{ $t('key1002998') }}</Button>
            </div>
          </div>
        </draggable>
      </div>
      <!--问卷设置-->
      <Card :bordered="false" dis-hover class="questionnaire_setting_box">
        <template #title>
          <h2 class="title_box">{{ $t('key1002999') }}</h2>
        </template>
        <Form ref="pageParams" :model="questionnaireSetting" label-position="top" @submit.native.prevent>
          <FormItem :label="$t('key1002992')">
            <Select v-model="questionnaireSetting.throwChannal" transfer>
              <Option v-for="item in launchChannelList" :key="item.value" :value="item.value">{{ item.title }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="$t('key1002993')">
            <div class="flex flex-direction">
              <Select v-model="questionnaireSetting.showWay" transfer class="mb10">
                <Option v-for="item in displayModeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
              <Select v-model="questionnaireSetting.skipOperShow" transfer>
                <Option v-for="item in operationModeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </div>
          </FormItem>
          <FormItem :label="$t('key1002994')">
            <Select v-model="questionnaireSetting.eventType" transfer>
              <Option v-for="item in triggerEventList" :key="item.value" :value="item.value">{{ item.title }}</Option>
            </Select>
          </FormItem>
        </Form>
      </Card>
    </div>
    <!--底部操作按钮-->
    <div class="options_content">
      <Button class="mr15" @click="questionnaireCancelBtn">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" @click="questionnaireBtn"
        v-if="getPermission('ymsQuestionnaire_create') || getPermission('ymsQuestionnaire_update')">{{ $t('key1000555') }}</Button>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import draggable from 'vuedraggable';
import {getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: "questionnaire",
  mixins: [Mixin],
  data() {
    return {
      typeObj: [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000394'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000395'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002975')],
      launchChannelList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002468'), value: 1}
      ], // 投放渠道
      displayModeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002976'), value: 1}
      ], // 显示方式
      operationModeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002977'), value: 0},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002978'), value: 1},
      ], // 显示的操作方式
      triggerEventList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002979'), value: 1}
      ],
      questionnaireSetting: {
        throwChannal: 1,
        showWay: 1, // 显示方式
        skipOperShow: 1,
        eventType: 1 // 触发事件
      },
      questionnaireTitle: '',
      direction: '',
      questionnaireList: [
        {
          questionType: 1, // 1单选,2多选,3文本
          mandatory: 1, // 0 非必填    1 必填
          questionTitle: '',
          ymsQuestionnaireQuestionsItems: [
            {itemContent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002980'), editType: false, otherType: 0},
            {itemContent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002980'), editType: false, otherType: 0},
          ]
        }
      ],
      disabledCard: false,
      disabledOptions: false,
      editoptions: false,
      eidtTalg: false,
      ymsQuestionnaireId: null,
      questionnaireInfo: {},
      ymsQuestionnaireQuestionBos: [],
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 题型
    questionTypeList() {
      const ENUM_KEY = 'YmsQuestionnaireQuestionQuestionTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsQuestionnaireQuestionQuestionTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      let path = this.$route.path;
      if (path === '/addQuestionnaire') {
        this.eidtTalg = false;
      } else {
        this.eidtTalg = true;
        this.ymsQuestionnaireId = this.$route.query.ymsQuestionnaireId;
        this.getQuestionnaireDetails(this.ymsQuestionnaireId);
      }
    },
    // 移除问卷题型
    deleteQuestionnaireBtn(index) {
      this.questionnaireList.splice(index, 1);
    },
    // 选择题型
    selectQuestionBtn(type) {
      this.questionnaireList.push({
        questionType: type,
        mandatory: 1, // 0 非必填    1 必填
        questionTitle: '',
        ymsQuestionnaireQuestionsItems: [
          {itemContent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002980'), editType: false, otherType: 0},
          {itemContent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002980'), editType: false, otherType: 0}
        ]
      });
    },
    // 编辑选项标题
    editOptionTitle(id, currentIndex, tagIndex) {
      let v = this;
      setTimeout(() => {
        v.questionnaireList.map((item, index) => {
          if (index === currentIndex) {
            item.ymsQuestionnaireQuestionsItems.map((ele, idx) => {
              ele.editType = false;
              if (idx === tagIndex) {
                if (!ele.otherType) {
                  ele.editType = true;
                  v.disabledCard = true;
                  v.disabledOptions = true;
                  v.editoptions = true;
                  v.$nextTick(() => {
                    v.getFocus(id + tagIndex);
                  });
                }
              }
            });
          }
        });
        v.$forceUpdate();
      }, 400);
    },
    // 移除选项标题
    deleteOptionTitle(currentIndex, tagIndex) {
      let v = this;
      v.questionnaireList.map((item, index) => {
        if (index === currentIndex) {
          item.ymsQuestionnaireQuestionsItems.map((ele, idx) => {
            if (idx === tagIndex) {
              item.ymsQuestionnaireQuestionsItems.splice(idx, 1);
            }
          });
        }
      });
      v.$forceUpdate();
    },
    // 失去焦点时，切换编辑标题的状态
    OptionBlur(currentIndex, tagIndex) {
      let v = this;
      v.disabledCard = false;
      v.disabledOptions = false;
      v.editoptions = false;
      setTimeout(() => {
        v.questionnaireList.map((item, index) => {
          if (index === currentIndex) {
            item.ymsQuestionnaireQuestionsItems.map((ele, idx) => {
              ele.editType = false;
              if (idx === tagIndex) {
                if (ele.itemContent === '') {
                  ele.itemContent = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002980');
                }
              }
            });
          }
        });
        v.$forceUpdate();
      }, 300);
    },
    // 添加选项
    addOptionsBtn(currentIndex) {
      let v = this;
      v.questionnaireList.map((item, index) => {
        if (index === currentIndex) {
          item.ymsQuestionnaireQuestionsItems.push({
            itemContent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002980'),
            editType: false,
            otherType: 0
          });
        }
      });
      v.$forceUpdate();
    },
    // 添加其他选项
    addOtherOptionsBtn(currentIndex) {
      let v = this;
      v.questionnaireList.map((item, index) => {
        if (index === currentIndex) {
          let talg = item.ymsQuestionnaireQuestionsItems.some((talg) => {
            return talg.otherType;
          });
          if (!talg) {
            item.ymsQuestionnaireQuestionsItems.push({
              itemContent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002981'),
              editType: false,
              otherType: 1
            });
          }
        }
      });
      v.$forceUpdate();
    },
    // 取消问卷操作
    questionnaireCancelBtn() {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002982'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002983'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000555'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002984'),
        onOk: () => {
          v.questionnaireBtn();
        },
        onCancel: () => {
          v.$router.push('/questionnaireInvestigation');
        }
      });
    },
    // 保存问卷操作
    questionnaireBtn() {
      let v = this;
      if (v.handlerParams()) {
        let methods = '';
        let text = '';
        let url = '';
        let query = {
          direction: v.direction,
          eventType: v.questionnaireSetting.eventType,
          merchantId: v.userInfo.merchantId,
          questionnaireTitle: v.questionnaireTitle,
          showWay: v.questionnaireSetting.showWay,
          skipOperShow: v.questionnaireSetting.skipOperShow,
          throwChannal: v.questionnaireSetting.throwChannal,
          ymsQuestionnaireQuestions: v.ymsQuestionnaireQuestionBos
        };
        // 新增
        if (!v.eidtTalg) {
          methods = 'post';
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002985');
          url = api.post_ymsQuestionnaire;
          query.status = 0;
        }
        // 编辑
        else {
          methods = 'put';
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001205');
          url = api.put_ymsQuestionnaire;
          query.ymsQuestionnaireId = v.questionnaireInfo.ymsQuestionnaireId;
          query.status = v.questionnaireInfo.status;
        }
        v.axios[methods](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
          if (res.data.code === 0) {
            v.$Message.success(text);
            v.$router.push('/questionnaireInvestigation');
          }
        });
      }
    },
    // 处理问卷的参数
    handlerParams() {
      let v = this;
      v.ymsQuestionnaireQuestionBos = [];
      let verificationTalg = true;
      for (let i = 0; i < v.questionnaireList.length; i++) {
        let item = v.questionnaireList[i];
        if (!item.questionTitle) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002986'));
          verificationTalg = false;
          return false;
        } else {
          const titleList = v.questionnaireList.map(value => value.questionTitle);
          const newTitleList = new Set(titleList);
          if (newTitleList.size !== titleList.length) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002987'));
            verificationTalg = false;
            return false;
          }
        }
        if (v.eidtTalg) {
          item.sortNo = i;
          item.ymsQuestionnaireQuestionsItems = item.questionType !== 3 ? item.ymsQuestionnaireQuestionsItems.map((talg, idx) => {
            talg.sortNo = idx;
            let {editType, ...obj} = talg;
            return obj;
          }) : [];
          v.ymsQuestionnaireQuestionBos.push(item);
        } else {
          v.ymsQuestionnaireQuestionBos.push({
            answerContent: item.questionType === 1 ? [item.ymsQuestionnaireQuestionsItems[0].itemContent] : [],
            mandatory: item.mandatory,
            questionTitle: item.questionTitle,
            questionType: item.questionType,
            sortNo: i,
            ymsQuestionnaireQuestionsItems: item.questionType !== 3 ? item.ymsQuestionnaireQuestionsItems.map((ele, ids) => {
              return {
                itemContent: ele.itemContent,
                sortNo: ids,
                otherType: ele.otherType
              };
            }) : []
          });
        }
      }
      return verificationTalg;
    },
    // 获取问卷的详情数据
    getQuestionnaireDetails(ymsQuestionnaireId) {
      let v = this;
      v.axios.get(api.get_ymsQuestionnaire + ymsQuestionnaireId, {loading: true}).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            v.questionnaireInfo = data;
            let settingKeyList = ['throwChannal', 'showWay', 'skipOperShow', 'eventType'];
            for (let key in data) {
              if (settingKeyList.includes(key)) {
                v.questionnaireSetting[key] = data[key];
              }
            }
            v.direction = data.direction;
            v.questionnaireTitle = data.questionnaireTitle;
            let list = data.ymsQuestionnaireQuestions;
            if (list && list.length > 0) {
              list.map((item) => {
                if (item.ymsQuestionnaireQuestionsItems) {
                  item.ymsQuestionnaireQuestionsItems.map((ele) => {
                    ele.editType = false;
                  });
                }
              });
              v.questionnaireList = list;
            }
          }
        }
      });
    }
  },
  watch: {
    questionnaireList: {
      handler(data) {
        if (data.length <= 1) {
          this.disabledCard = true;
        } else {
          if (!this.editoptions) {
            this.disabledCard = false;
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    draggable
  }
};
</script>

<style lang="less" scoped>
.questionnaire_box {
  width: 100%;
  margin-top: 20px;
  display: flex;
  padding-bottom: 50px;

  .question_type_box {
    width: 150px;
    background-color: #fff;
    height: calc(100vh - 200px);

    .title_box {
      font-size: 17px;
      color: #000;
      font-weight: bold;
    }

    .question_type_item {
      display: flex;
      flex-direction: column;
      align-items: center;

      /deep/ .ivu-btn {
        width: 100px;
        margin-bottom: 15px;
      }
    }
  }

  .questionnaire_content {
    flex: 1;
    margin: 0 20px 0 20px;
    max-height: 700px;
    overflow-y: auto;
    padding-right: 20px;

    .questionnaire_title {
      background-color: #fff;
      width: 100%;
      padding: 20px;
      border-radius: 4px;

      .title {
        /deep/ .ivu-input {
          font-size: 18px;
          color: #000;
          font-weight: bold;
          padding: 18px 10px;
          height: initial;
          line-height: initial;
          text-align: center;
        }

        /deep/ .ivu-input::-webkit-input-placeholder {
          font-size: 18px;
          color: #C0C0C0;
          font-weight: initial;
        }

        /deep/ .ivu-input:-moz-placeholder {
          font-size: 18px;
          color: #C0C0C0;
          font-weight: initial;
        }

        /deep/ .ivu-input::-moz-placeholder {
          font-size: 18px;
          color: #C0C0C0;
          font-weight: initial;
        }

        /deep/ .ivu-input:-ms-input-placeholder {
          font-size: 18px;
          color: #C0C0C0;
          font-weight: initial;
        }
      }

      .text {
        margin-top: 20px;

        /deep/ .ivu-input {
          font-size: 14px;
          color: #666;
          height: initial;
          line-height: initial;
        }
      }
    }

    .questionnaire_list {
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      .questionnaire_list_item {
        width: 100%;
        border-radius: 4px;
        background-color: #fff;
        padding: 20px 20px 0 20px;
        margin-bottom: 20px;
        box-sizing: border-box;
        position: relative;
        border: 1px solid transparent;

        .deleteIcon {
          display: none;
          position: absolute;
          top: 10px;
          right: 10px;
          cursor: pointer;
        }

        &:hover {
          .deleteIcon {
            display: inline-block;
          }

          border: 1px dashed #2D8CF0;
        }

        .title {
          color: #333333;
          font-size: 14px;
          font-weight: 600;
          height: 32px;
          line-height: 32px;
        }

        .required_styles:before {
          content: '*';
          display: inline-block;
          margin-right: 4px;
          line-height: 1;
          font-family: SimSun;
          font-size: 12px;
          color: #ed4014;
          position: relative;
          top: -4px;
        }

        .option_box {
          max-width: 600px;

          .option_box_item {
            display: flex;
            flex-direction: column;

            .option_box_item_box {
              display: flex;
              align-items: center;
              margin-bottom: 15px;

              .moveIcon {
                opacity: 0;
                cursor: move;
                margin-left: 5px;
              }

              &:hover {
                .moveIcon {
                  opacity: 1;
                }
              }
            }

            .moveIconStyles {
              .moveIcon {
                opacity: 0 !important;
                cursor: initial !important;
              }
            }

            .radio_item, .checkbox_item {
              display: inline-block;
              width: 16px;
              height: 16px;
              position: relative;
              top: 0;
              left: 0;
              background-color: #fff;
              border: 1px solid #dcdee2;
              margin-right: 5px;
              margin-left: 15px;
            }

            .radio_item {
              border-radius: 50%;
            }

            .checkbox_item {
              border-radius: 2px;
            }
          }
        }

        .add_option_box {
          margin-top: 20px;
          border-top: 1px solid #E8E8E8;
          padding: 15px 0;
          display: flex;
          align-items: center;

          /deep/ .ivu-btn-text {
            border: none !important;
            padding: 0;
            box-shadow: initial !important;
          }
        }
      }

      .moveStyles {
        &:hover {
          cursor: move;
        }
      }
    }
  }

  .questionnaire_setting_box {
    width: 250px;
    background-color: #fff;
    height: calc(100vh - 200px);

    .title_box {
      font-size: 17px;
      color: #000;
      font-weight: bold;
    }

    /deep/ .ivu-form-item-label {
      font-size: 14px;
      color: #000;
      font-weight: bold;
    }

  }
}

.options_content {
  box-shadow: 0px -3px 10px 0px #c9cbce;
  position: fixed;
  min-width: 100%;
  z-index: 10;
  background-color: #fff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 15px;
}
</style>